import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { PriceEditService } from '../../service/price-edit/price-edit.service';

@Component({
	selector: 'app-price-edit',
	templateUrl: './price-edit.component.html',
	providers: [
		PriceEditService,
		HttpModule
	]
})
export class PriceEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	priceForm: FormGroup;
	ID: string;
	Nome: string;
	Peso: number;
	Valor: number;
	Ativo: boolean;

	constructor(fb: FormBuilder, private priceEditService: PriceEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.priceForm = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Peso': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Valor': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.priceEditService.loadPrice(this.token, this.ID).subscribe(result => {
				var updatePrice = result.Result;
				this.priceForm.setValue({
					ID: updatePrice.ID,
					Nome: updatePrice.Nome,
					Peso: updatePrice.Peso,
					Valor: updatePrice.Valor,
					Ativo: updatePrice.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editPrice(value: any) {
		this.priceEditService.editPrice(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Média Saca editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/media-saca');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/media-saca');
	}

}



// WEBPACK FOOTER //
// ./src/app/price/component/price-edit/price-edit.component.ts